export default {"src":"/_next/static/media/ISO.fa095f9d.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};